module.exports = __webpack_public_path__ + "static/Tacx-c6c075de9ae655e1f8e6bb04cac3d8bb.jpg";